
import React, { useState } from 'react';

import { amountFormatUse, local_utc_timestamp, convertDecimalToTime } from '../../../helpers/Helper';
import { post, get, del } from '../../../helpers/api_helper';
import { GET_DASHBOARD_DATA, GET_OPTION, POST_ATTENDANCE_EMPLOYEE_LIST, POST_EMPLOYEE_ATTENDANCE, POST_DELETE_ATTENDANCE } from '../../../helpers/url_helper';
import useMounted from '../../../hooks/useMounted';
import { toast } from 'react-toastify';
import { startOfMonth, subMonths } from 'date-fns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';

import { useTranslation } from 'react-i18next';

const Attendance = () => {
    const { t } = useTranslation();

    const [filter_option, setFilterOption] = useState({ date: local_utc_timestamp(new Date()), unitId: '', departmentId: '', shortBy: 'name' });
    const [selectEmployees, setSelectEmployees] = useState([]);
    const [ShowBulkAction, SetShowBulkAction] = useState(false);
    const [progressCount, SetProgressCount] = useState(0);
    const [isBulkAction, SetIsBulkAction] = useState(false);
    const [bulkActionType, SetBulkActionType] = useState('');

    const [units, setUnits] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [Overtime, SetOvertime] = useState(false);
    const [isLoading, SetIsLoading] = useState(false);
    const [employeeInfo, SetEmployeeInfo] = useState(null);
    const [key, SetKey] = useState(null);
    const [employeeOverTimeHours, SetEmployeeOverTimeHours] = useState(0);
    const [employeeOverTimeMinutes, SetEmployeeOverTimeMinutes] = useState(0);
    const [active_plan_info, SetActive_plan_info] = useState(null);


    useMounted(() => {
        async function get_detaile() {
            getactivePlanInfo();
            const api_res = await get(GET_OPTION);
            if (api_res.status) {
                setUnits(api_res.data.units);
                setDepartments(api_res.data.departments);
            }
            get_employees();
        }
        get_detaile();
    }, [])

    const getactivePlanInfo = async () => {
        var res_data = await post(GET_DASHBOARD_DATA, {});
        if (res_data.status) {
            SetActive_plan_info(res_data.data.active_plan_info);
        } else {
            toast.error(res_data.message);
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        filter_option[event.target.name] = event.target.value;
        setFilterOption({ ...filter_option });
        get_employees();
    }

    const get_employees = async () => {
        SetButtonDisabled(true);
        SetIsLoading(true);
        var api_res = await post(POST_ATTENDANCE_EMPLOYEE_LIST, filter_option);
        if (api_res.status) {
            setEmployees(api_res.data.employees);
            setSelectEmployees([]);
        } else {
            toast.error(api_res.message);
        }
        SetButtonDisabled(false);
        SetIsLoading(false);
    }

    const attendance = async (index, type, employee, overTimeHours = 0, overTimeMinutes = 0) => {
        if (!active_plan_info.plan_status) {
            toast.error(t('homePage.subscriptionExpired'));
            return;
        }
        if (overTimeHours === '') {
            toast.error('Please Enter You Hours');
            return;
        }
        if (overTimeMinutes === '') {
            toast.error('Please Enter You Minutes');
            return;
        }
        type = ((overTimeHours > 0 || overTimeMinutes > 0) && employee.attendanceType === 'Absent') ? 'Absent' : type;

        SetButtonDisabled(true);
        var api_post_data = {
            employeeId: employee.employeeId,
            date: filter_option.date,
            workingHours: employee.workingHours,
            salaryType: employee.salaryType,
            salary: employee.salary,
            attendanceType: type,
            overTimeHours: overTimeHours,
            overTimeMinutes: overTimeMinutes,
            offset: -new Date().getTimezoneOffset()
        }
        var api_res = await post(POST_EMPLOYEE_ATTENDANCE, api_post_data);
        if (api_res.status) {
            employees[index].atId = api_res.data.atId;
            employees[index].attendanceType = api_res.data.attendanceType;
            employees[index].overTimeHours = api_res.data.overTimeHours;
            employees[index].totalAmount = api_res.data.totalAmount;
            setEmployees([...employees]);
            $('.modal-close').click();

        } else {
            toast.error(api_res.message);
        }
        SetButtonDisabled(false);
    }

    const overTimeModal = async (key, employee) => {
        SetEmployeeInfo({ ...employee });
        SetOvertime(employee.salaryType !== 'Per Hour');
        SetKey(key);
    }

    const allowOnlyNumbers = (e) => {
        const value = e.target.value;
        const regex = /^\d*$/; // Only digits (no dot allowed)

        if (!regex.test(value)) {
            e.target.value = value.replace(/\D/g, ''); // Remove all non-digits
        }
        if (e.target.name === 'employeeOverTimeMinutes') {
            if (value > 59) {
                e.target.value = 59
            } else if (value && value <= 0) {
                e.target.value = ''
            }
        }
    }

    // remove user role
    const remove_row = async (index, id) => {
        var res_data = await del(`${POST_DELETE_ATTENDANCE}?id=${id}&offset=${-new Date().getTimezoneOffset()}`);
        if (res_data.status) {
            toast(res_data.message);
            employees[index].atId = null;
            employees[index].attendanceType = null;
            employees[index].overTimeHours = null;
            employees[index].totalAmount = null;
            setEmployees([...employees]);
        } else {
            toast.error(res_data.message);
        }
    }

    const onSelectEmployees = (employee) => {
        const exists = selectEmployees.some(e => e.employeeId === employee.employeeId);

        let updatedSelection;
        if (exists) {
            updatedSelection = selectEmployees.filter(e => e.employeeId !== employee.employeeId);
        } else {
            updatedSelection = [...selectEmployees, employee];
        }

        setSelectEmployees(updatedSelection);
        SetShowBulkAction(updatedSelection.length > 0)
    }

    const bulk_action = async (type) => {
        SetProgressCount(0);
        SetBulkActionType(type);
        if (selectEmployees.length > 0) {
            SetButtonDisabled(true);
            SetIsBulkAction(true);
            for (const employee of selectEmployees) {
                // Simulate processing
                SetProgressCount(prev => prev + 1);

                const api_post_data = {
                    employeeId: employee.employeeId,
                    date: filter_option.date,
                    workingHours: employee.workingHours,
                    salaryType: employee.salaryType,
                    salary: employee.salary,
                    attendanceType: type,
                    overTimeHours: 0,
                    overTimeMinutes: 0,
                    offset: -new Date().getTimezoneOffset()
                }
                var api_res = await post(POST_EMPLOYEE_ATTENDANCE, api_post_data);
                if (!api_res.status) {
                    toast.error(api_res.message);
                    SetButtonDisabled(false);
                    SetIsBulkAction(false);
                    get_employees();
                    return; // ⛔️ Stop execution here
                }
            }
            SetButtonDisabled(false);
            SetIsBulkAction(false);
            get_employees();
        }
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">

                            <div className='row mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Attendance Date</label>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.date} onChange={(date) => {
                                            handleInputChangeFilter({ target: { name: 'date', value: local_utc_timestamp(date) } })
                                        }}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                        minDate={startOfMonth(subMonths(new Date(), 1))}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Units</label>
                                    <select name='unitId' className='form-control' value={filter_option.unitId} onChange={handleInputChangeFilter}>
                                        <option value="">All Units</option>
                                        {units && units.map((unit, key) => {
                                            return (<option value={unit.unitId}>{unit.unitName}</option>)
                                        })}
                                    </select>
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Departments</label>
                                    <select name='departmentId' className='form-control' value={filter_option.departmentId} onChange={handleInputChangeFilter}>
                                        <option value="">All Departments</option>
                                        {departments && departments.map((department, key) => {
                                            return (<option value={department.departmentId}>{department.departmentName}</option>)
                                        })}
                                    </select>
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Short By</label>
                                    <select name='shortBy' className='form-control' value={filter_option.shortBy} onChange={handleInputChangeFilter}>
                                        <option value="name">Name - ASC</option>
                                        <option value="employeeId">Employee Id - ASC</option>
                                        <option value="employeeCode">Employee Code - ASC</option>

                                    </select>
                                </div>
                            </div>
                            <hr />
                            {isLoading && <i className="fa fa-spinner me-2 fa-spin"></i>}
                            {(!isLoading && employees.length > 0) && <>
                                <div className='row position' onClick={() => { SetShowBulkAction(!ShowBulkAction) }}>
                                    <div className='col-10'>
                                        <h6 className='mb-0'>Bulk action {selectEmployees.length > 0 && <small className='bg-success text-white ps-2 pe-2 pt-1 pb-1 rounded-1' style={{ "fontSize": "9px" }}>{selectEmployees.length} Employees Selected</small>}</h6>
                                    </div>
                                    <div className='col-2 text-right'>
                                        {!ShowBulkAction && <i className="menu-icon tf-icons bx bx-chevron-right"></i>}
                                        {ShowBulkAction && <i className="menu-icon tf-icons bx bx-chevron-down"></i>}
                                    </div>
                                </div>
                                {ShowBulkAction &&
                                    <div className='row'>
                                        <div className='col-sm-12 pt-2'>
                                            <label className='me-3 mb-2'>
                                                <input type='checkbox' disabled={ButtonDisabled} onClick={(e) => { setSelectEmployees((e.target.checked) ? employees : []) }} checked={(selectEmployees.length > 0 && selectEmployees.length === employees.length) ? true : false} className='me-2 checkbox' />
                                                All Select
                                            </label>
                                            <button disabled={ButtonDisabled || selectEmployees.length <= 0} onClick={() => { bulk_action('Full Day') }} class={`btn btn-sm btn-outline-success me-3 mb-2 w-sm-auto w-100`}>PRESENT</button>
                                            <button disabled={ButtonDisabled || selectEmployees.length <= 0} onClick={() => { bulk_action('Half Day') }} class={`btn btn-sm btn-outline-info me-3 mb-2 w-sm-auto w-100`}>HALF DAY</button>
                                            <button disabled={ButtonDisabled || selectEmployees.length <= 0} onClick={() => { bulk_action('Absent') }} class={`btn btn-sm btn-outline-danger me-3 mb-2 w-sm-auto w-100`}>ABSENT</button>
                                        </div>
                                        {isBulkAction && <div className='col-sm-12 mt-3'>
                                            <small className="mb-1">✔️ Action: Marking employees as <strong className='me-2'>{bulkActionType}</strong> {progressCount}/{selectEmployees.length}</small>
                                            <div className="progress my-2" style={{ height: '6px' }}>
                                                <div className="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar" style={{ width: `${(progressCount * 100 / selectEmployees.length)}%` }} />
                                            </div>
                                            <small className="text-muted">⏳ Please wait... This may take a few seconds.</small>
                                        </div>}
                                    </div>
                                }
                                <hr />
                            </>}
                            {!isLoading && <div className='row'>
                                {employees.length <= 0 && <div className='col-sm-12 text-center p-5'>No any employees</div>}
                                {employees && employees.map((employee, key) => {
                                    return (
                                        <div className='col-sm-6 col-md-6 col-lg-4 mt-3' key={`employee-${key}`}>
                                            <div class="card shadow-sm border">
                                                <div class="card-body d-flex flex-column align-items-start p-3">
                                                    <input type='checkbox' disabled={ButtonDisabled} checked={selectEmployees.some(e => e.employeeId === employee.employeeId)} onClick={() => { onSelectEmployees(employee) }} className='attendance-custom-checkbox' />
                                                    <div class="d-flex align-items-center mb-3">
                                                        <div class="rounded-circle bg-primary text-white fw-bold d-flex align-items-center justify-content-center me-3" style={{ "width": "50px", "height": "50px" }}>
                                                            {employee.name.trim().slice(0, 2).toUpperCase()}
                                                        </div>
                                                        <div>
                                                            <h5 class="mb-0">{employee.name}</h5>
                                                            <small class="text-muted">E-{employee.employeeId} , {employee.employeeCode}</small>
                                                            {employee.atId > 0 && <button className="btn btn-sm text-danger" onClick={() => { remove_row(key, employee.atId) }} style={{ "position": "absolute", "top": "-4px", "right": "-8px" }}><i className="bx bx-trash-alt align-middle"></i></button>}
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-2 mb-2 attendance-btn">
                                                        {employee.salaryType !== 'Per Hour' && <>
                                                            <button disabled={ButtonDisabled} onClick={() => { attendance(key, 'Full Day', employee) }} class={`btn btn-sm btn-outline-success ${((employee.attendanceType === 'Full Day')) ? 'active' : ''}`}>PRESENT</button>
                                                            <button disabled={ButtonDisabled} onClick={() => { attendance(key, 'Half Day', employee) }} class={`btn btn-sm btn-outline-info ${((employee.attendanceType === 'Half Day')) ? 'active' : ''}`}>HALF DAY</button>
                                                        </>}
                                                        <button disabled={ButtonDisabled} onClick={() => { attendance(key, 'Absent', employee) }} class={`btn btn-sm btn-outline-danger ${((employee.attendanceType === 'Absent')) ? 'active' : ''}`}>ABSENT</button>
                                                        <button disabled={ButtonDisabled} class={`btn btn-sm btn-outline-warning ${((employee.overTimeHours > 0)) ? 'active' : ''}`} onClick={() => { overTimeModal(key, employee) }} data-bs-toggle="modal" data-bs-target="#OvertimeModal">{(employee.salaryType !== 'Per Hour') ? 'OVER TIME' : 'WORKING HOURS'}</button>
                                                    </div>
                                                    {employee.atId > 0 && <>
                                                        {employee.attendanceType === 'Half Day' && <small class="text-info"> ✓ Marked as Half Day <span className='text-danger'> {amountFormatUse(employee.totalAmount)}</span></small>}
                                                        {(employee.attendanceType === 'Full Day' && employee.overTimeHours <= 0) && <small class="text-success">✓ Marked as Present <span className='text-danger'> {amountFormatUse(employee.totalAmount)}</span></small>}
                                                        {(employee.overTimeHours > 0) && <small class="text-warning">✓ Marked as {(employee.salaryType !== 'Per Hour') ? 'Over Time' : 'Working'} (+{convertDecimalToTime(employee.overTimeHours)}h)  <span className='text-danger'>{amountFormatUse(employee.totalAmount)}</span></small>}

                                                    </>}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="OvertimeModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-sm" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{(Overtime) ? 'Enter Overtime Hours' : 'Enter Working Hours'}</h5>
                            <button type="button" className="btn btn-sm modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-6 pe-0'>
                                    <label className='form-label text-capitalize'>Enter Hours *</label>
                                    <input type='text' className='form-control' name='employeeOverTimeHours' placeholder='Hours' value={employeeOverTimeHours} onKeyUp={allowOnlyNumbers} maxLength={2} onChange={(e) => { SetEmployeeOverTimeHours(e.target.value); }} />
                                </div>
                                <div className='col-6 ps-0'>
                                    <label className='form-label text-capitalize'>Enter Minutes *</label>
                                    <input type='text' className='form-control' name='employeeOverTimeMinutes' placeholder='Minutes' value={employeeOverTimeMinutes} onKeyUp={allowOnlyNumbers} maxLength={2} onChange={(e) => { SetEmployeeOverTimeMinutes(e.target.value); }} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={ButtonDisabled} className="btn btn-secondary" data-bs-dismiss="modal">{t('cancel')}</button>
                            <button onClick={() => { attendance(key, 'Full Day', employeeInfo, employeeOverTimeHours, employeeOverTimeMinutes); }} disabled={ButtonDisabled} className="btn btn-primary">{t('save')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Attendance;